document.addEventListener('DOMContentLoaded', () => {
      // Loop through each faq-container and open the first faq-item in each
      document.querySelectorAll('.faq-container').forEach(container => {
          const firstFaqItem = container.querySelector('.faq-item');
          if (firstFaqItem) {
              firstFaqItem.classList.add('active');
              firstFaqItem.querySelector('.faq-answer').style.display = 'block';
          }

          // Add click event listener for each faq-item inside this container
          container.querySelectorAll('.faq-item').forEach(item => {
              item.addEventListener('click', () => {
                  // Hide all other faq-answer elements within this container
                  container.querySelectorAll('.faq-answer').forEach(answer => {
                      if (answer !== item.querySelector('.faq-answer')) {
                          answer.style.display = 'none';
                          answer.parentElement.classList.remove('active');
                      }
                  });

                  // Toggle the clicked item
                  const answer = item.querySelector('.faq-answer');
                  if (answer.style.display === 'block') {
                      answer.style.display = 'none';
                      item.classList.remove('active');
                  } else {
                      answer.style.display = 'block';
                      item.classList.add('active');
                  }
              });
          });
      });
  });